import { render, staticRenderFns } from "./InfoCards.vue?vue&type=template&id=0f689090"
import script from "./InfoCards.vue?vue&type=script&lang=js"
export * from "./InfoCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports